import { render, staticRenderFns } from "./DeliveryPerPriceByArea.vue?vue&type=template&id=7dd95bff&lang=pug&"
import script from "./DeliveryPerPriceByArea.vue?vue&type=script&lang=ts&"
export * from "./DeliveryPerPriceByArea.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryPerPriceByArea.vue?vue&type=style&index=0&id=7dd95bff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports